import { axiosInstance } from 'utils/http';
import { dataCredential } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchOrgCredentialsCrAdmin = (orgId, credentialSourceName) => {
  const dispatch = useDispatch();

  return useQuery(
    ['OrgCredentials', 'CrAdmin', orgId, credentialSourceName],
    () => axiosInstance.get(dataCredential(orgId).listOrgCredentialsForCleanroomAdmin, {
      params: {
        credentialSourceName,
        includeCredential: true,
      },
    }),
    {
      select: res => res?.data?.credentials,
      enabled: !!orgId && !!credentialSourceName,
      onError: () => dispatch(showAlert({
        message: 'Error fetching credentials',
        type: 'error',
      })),
    },
  );
};
